import PropTypes from 'prop-types';
import React from 'react';
import { isNumber } from "../utils/commonUtility";
import { currencyTypes } from "../utils/localeData";
import FormattedNumber from "../FormattedNumber/FormattedNumber";

var FormattedCurrency = function FormattedCurrency(_ref) {
  var currency = _ref.currency,
      value = _ref.value,
      maximumFractionDigits = _ref.maximumFractionDigits;

  if (!isNumber(value) || !currency || typeof currency !== 'string') {
    return '';
  }

  var upperCaseCurrency = currency.toUpperCase();
  var specialLocales = ['USD', 'UAH'];
  return React.createElement(FormattedNumber, {
    value: +value
    /* eslint-disable-next-line react/style-prop-object */
    ,
    style: "currency",
    currency: upperCaseCurrency,
    currencyDisplay: specialLocales.includes(upperCaseCurrency) ? 'narrowSymbol' : undefined,
    maximumFractionDigits: maximumFractionDigits,
    "data-qa": "formatted-currency"
  });
};

FormattedCurrency.defaultProps = {
  currency: 'USD',
  maximumFractionDigits: 2
};
FormattedCurrency.propTypes = {
  /** value is required */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,

  /** currency type (USD,EUR,...) */
  currency: PropTypes.oneOf(currencyTypes),

  /* Maximum numbers after decimal point */
  maximumFractionDigits: PropTypes.number
};
export default FormattedCurrency;